// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".btn.btn-success .fa-check {\n  font-size: 16px !important;\n  margin-right: 3px;\n}\n\n.btn.btn-info .fa-save {\n  font-size: 16px !important;\n  margin-right: 3px;\n}\n\n.ajusteProdutoNFE .crud-grid tbody tr td {\n  padding: 14px 8px;\n}\n.ajusteProdutoNFE .crud-grid tbody tr td .crud-grid .table-foot {\n  background-color: #eee;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
